/**
 * Trinkgeld bei Kartenzahlung: Vorschläge für die Kassierkraft (Gastro-üblich:
 * aufrunden, 5 %, 10 %). Beträge in Cent (Regel 5). Das Trinkgeld geht in den
 * Terminalbetrag, nicht in den Beleg (kein Umsatz).
 */
export interface TrinkgeldVorschlag {
  text: string;
  trinkgeldCent: number;
}

/** Prozentualer Vorschlag, auf 10 Cent gerundet, mindestens 10 Cent. */
export function trinkgeldProzent(restCent: number, prozent: number): number {
  if (restCent <= 0) {
    return 0;
  }
  return Math.max(10, Math.round((restCent * prozent) / 100 / 10) * 10);
}

/** Aufrunden auf den nächsten vollen Euro (bei Beträgen über 20 € auf volle 5 €). */
export function trinkgeldAufrunden(restCent: number): number {
  if (restCent <= 0) {
    return 0;
  }
  const schritt = restCent > 2_000 ? 500 : 100;
  const rest = restCent % schritt;
  return rest === 0 ? schritt : schritt - rest;
}

export function trinkgeldVorschlaege(restCent: number): TrinkgeldVorschlag[] {
  if (restCent <= 0) {
    return [];
  }
  const liste: TrinkgeldVorschlag[] = [{ text: 'Kein Trinkgeld', trinkgeldCent: 0 }];
  const auf = trinkgeldAufrunden(restCent);
  liste.push({ text: `Aufrunden (+${formatCent(auf)})`, trinkgeldCent: auf });
  for (const p of [5, 10]) {
    const cent = trinkgeldProzent(restCent, p);
    if (!liste.some((v) => v.trinkgeldCent === cent)) {
      liste.push({ text: `${String(p)} % (+${formatCent(cent)})`, trinkgeldCent: cent });
    }
  }
  return liste;
}

function formatCent(cent: number): string {
  return `${String(Math.floor(cent / 100))},${String(cent % 100).padStart(2, '0')} €`;
}
